export { phpCurl } from './curl.js';
